<template>
  <Modal :title="'Zapytanie o ofertę i dostępne promocje'">
    <template #content>
      <div class="modal" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal__header">
          <p>{{ $t('ASK_FOR_OFFER') }}</p>
        </div>
        <div class="modal__actions">
          <button
            type="button"
            class="btn btn-close mobile--hide"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none">
              <path
                d="M2 23L23.9203 1.07969"
                stroke="white"
                stroke-width="3"></path>
              <path
                d="M24 23L2.07969 1.07969"
                stroke="white"
                stroke-width="3"></path>
            </svg>
          </button>
          <button
            type="button"
            class="btn btn-close mobile--show"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="15"
              viewBox="0 0 26 25"
              fill="none">
              <path
                d="M2 23L23.9203 1.07969"
                stroke="white"
                stroke-width="3"></path>
              <path
                d="M24 23L2.07969 1.07969"
                stroke="white"
                stroke-width="3"></path>
            </svg>
          </button>
        </div>
        <div class="modal__content">
          <div
            class="modal-content"
            style="
              background: center / cover no-repeat
                url('../src/easly_img_new/background_modal.png');
            ">
            <div
              class="modal__content--body"
              style="
                grid-template-columns: auto;
                justify-items: center;
                text-align: center;
                gap: 40px;
                margin-bottom: 40px;
              ">
              <div class="content__body--img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="70"
                  viewBox="0 0 45 70"
                  fill="none">
                  <path
                    d="M16.1991 32.0327C12.8822 34.4093 9.56839 36.7829 6.2515 39.1594C6.23612 38.7839 6.11919 38.3826 6.22073 38.0385C8.28225 31.2558 10.3838 24.4846 12.4299 17.6961C12.7068 16.7759 13.1991 16.4749 14.1745 16.5609C16.1406 16.7386 17.5376 17.6761 18.3775 19.29C19.9622 22.3317 19.9068 25.5711 19.4852 28.822C19.436 29.2061 18.9191 29.5587 18.5745 29.8827C17.7991 30.6137 16.996 31.316 16.2022 32.0327H16.1991Z"
                    fill="#1D1D1D" />
                  <path
                    d="M16.5049 32.3183C21.9756 28.3794 27.4494 24.4405 32.9201 20.5016C34.1755 19.5957 35.4063 18.6554 36.6862 17.7782C39.0955 16.1269 42.1908 16.5082 43.9354 18.6353C45.64 20.7166 45.28 23.5833 42.9816 25.2804C38.4801 28.6001 33.9417 31.8711 29.3879 35.1248C28.9509 35.4373 28.2802 35.4631 27.7171 35.6208C26.5633 35.9447 25.4063 36.2687 24.2494 36.5926C24.3325 36.8076 24.4125 37.0255 24.4956 37.2405C24.8894 37.0742 25.2771 36.8993 25.6771 36.7417C27.4679 36.0365 29.1909 36.111 30.7355 37.272C32.2801 38.4302 32.7417 39.9725 32.3755 41.7642C32.2124 42.5669 31.8648 43.0227 30.8494 42.9654C29.5109 42.888 28.354 43.3438 27.4217 44.1608C27.4863 44.2927 27.5509 44.4274 27.6156 44.5593C28.0402 44.3844 28.4679 44.2095 28.8925 44.0318C30.7171 43.2721 32.8124 43.5588 34.1693 44.8316C35.6001 46.1704 36.0124 47.7901 35.3324 49.5732C34.9663 50.5278 34.4432 51.2847 33.0647 51.3563C32.114 51.4051 31.194 51.9985 30.2617 52.3482C30.3448 52.5288 30.4248 52.7066 30.5078 52.8872C30.8217 52.7696 31.1478 52.6722 31.4463 52.5317C33.7755 51.4366 36.3109 51.9727 37.7201 53.8705C39.117 55.7482 38.7662 58.2308 36.7939 59.7989C33.9478 62.0607 31.0863 64.3083 28.1725 66.4927C21.4095 71.5554 13.8095 71.1111 7.78804 65.3202C5.16345 62.7946 3.09577 59.8935 1.58194 56.6741C-1.3688 50.4046 -0.208813 45.4164 5.20653 40.7723C5.68652 40.3595 6.10806 39.8922 6.55728 39.4479C9.87418 37.0713 13.188 34.6977 16.5049 32.3212V32.3183Z"
                    fill="#1D1D1D" />
                  <path
                    d="M42.7941 6.01755C42.824 6.09455 42.8059 6.18192 42.7478 6.24067C42.6751 6.31423 42.6073 6.39047 42.5335 6.47345C42.4817 6.53167 42.4269 6.5932 42.3655 6.65945C42.2248 6.81116 42.0641 6.96974 41.8745 7.10023C41.745 7.18938 41.6155 7.27853 41.486 7.36769C38.693 9.29084 35.8981 11.2153 33.0552 13.0743L42.7941 6.01755ZM42.7941 6.01755C42.5814 5.46921 42.2973 5.12107 41.91 5.0217C41.5304 4.92429 41.1366 5.08967 40.7637 5.34396L40.7636 5.34401C40.1043 5.79406 39.4442 6.24327 38.7841 6.69252C36.4267 8.29687 34.0685 9.9017 31.7427 11.5466C31.5142 11.707 31.4158 11.9845 31.3525 12.2191C31.3284 12.3088 31.3068 12.4036 31.2862 12.4935C31.2789 12.5256 31.2718 12.557 31.2647 12.5873C31.2367 12.7071 31.2088 12.8154 31.1742 12.9103C31.1503 12.9757 31.1605 13.0487 31.2013 13.1051M42.7941 6.01755L31.2013 13.1051M31.2013 13.1051C31.2421 13.1614 31.3083 13.1939 31.3779 13.1916M31.2013 13.1051L31.3779 13.1916M31.3779 13.1916C31.4996 13.1877 31.6326 13.1945 31.7753 13.2045M31.3779 13.1916L31.7753 13.2045M31.7753 13.2045C31.8111 13.207 31.8479 13.2097 31.8852 13.2124M31.7753 13.2045L31.8852 13.2124M31.8852 13.2124C31.9924 13.2203 32.1038 13.2286 32.2109 13.2328M31.8852 13.2124L32.2109 13.2328M32.2109 13.2328C32.49 13.2439 32.812 13.2336 33.055 13.0744L32.2109 13.2328Z"
                    fill="#1D1D1D"
                    stroke="#1D1D1D"
                    stroke-width="0.419229"
                    stroke-linejoin="round" />
                  <path
                    d="M22.2379 2.56589C22.1672 2.5669 22.1046 2.59051 22.0568 2.61504C22.0072 2.64051 21.9602 2.6739 21.9175 2.70948C21.8323 2.78063 21.749 2.8734 21.6778 2.97038C21.6066 3.06742 21.5419 3.17627 21.4981 3.28267C21.4579 3.38017 21.42 3.51182 21.4492 3.63716L21.4491 3.63716L21.4494 3.63806C22.1238 6.47848 22.8475 9.3079 23.6392 12.1233L23.6396 12.1249C23.6758 12.2499 23.767 12.3459 23.8538 12.415C23.9448 12.4873 24.0557 12.5498 24.1697 12.6015C24.3967 12.7045 24.666 12.7787 24.8821 12.7998L24.8825 12.7999C25.1178 12.8225 25.3503 12.7678 25.5146 12.7141C25.5986 12.6866 25.6692 12.6579 25.7192 12.6359C25.7443 12.6248 25.7643 12.6153 25.7786 12.6084L25.7954 12.6001L25.8004 12.5976L25.802 12.5967L25.8025 12.5964L25.8028 12.5963L25.8029 12.5963L25.7056 12.4106L25.8029 12.5962C25.8884 12.5514 25.9322 12.4541 25.9091 12.3605C25.906 12.348 25.9019 12.336 25.8968 12.3246C25.716 11.6261 25.5429 10.9537 25.3751 10.3023C24.7105 7.72146 24.1306 5.46966 23.4982 3.22918M22.2379 2.56589C22.4592 2.56243 22.737 2.63785 22.9646 2.74229C23.0804 2.79546 23.1928 2.86044 23.2844 2.93492C23.3712 3.00539 23.4632 3.10354 23.4982 3.22918M22.2379 2.56589C22.2378 2.56589 22.2377 2.56589 22.2377 2.5659L22.241 2.77548M22.2379 2.56589C22.238 2.56589 22.2381 2.56589 22.2382 2.56589L22.241 2.77548M23.4982 3.22918C23.4982 3.22906 23.4981 3.22894 23.4981 3.22882L23.2964 3.28576L23.4984 3.22974C23.4983 3.22955 23.4983 3.22937 23.4982 3.22918ZM21.6533 3.58964C22.3271 6.42771 23.0502 9.25432 23.841 12.0666C23.9148 12.3217 24.521 12.5539 24.9025 12.5912L21.6533 3.58964ZM21.6533 3.58964C21.5979 3.3517 22.0287 2.77835 22.241 2.77548M21.6533 3.58964L22.241 2.77548"
                    fill="#1D1D1D"
                    stroke="#1D1D1D"
                    stroke-width="0.419229"
                    stroke-linejoin="round" />
                  <path
                    d="M28.7918 11.1426C28.9184 11.1489 29.0524 11.1161 29.1742 11.0694C29.2987 11.0215 29.4248 10.9535 29.5401 10.8751C29.6553 10.7968 29.7645 10.7049 29.8529 10.6066C29.9389 10.511 30.0173 10.3961 30.0509 10.2709C30.7687 7.59573 31.4187 4.90642 32.0101 2.20587L32.0102 2.20538C32.0655 1.94999 31.9447 1.69314 31.8359 1.49707C31.7935 1.42071 31.7459 1.34213 31.7008 1.26765C31.6849 1.24124 31.6692 1.21535 31.6542 1.19025C31.5946 1.09073 31.5427 0.999589 31.5042 0.914007C31.4783 0.856576 31.4281 0.813803 31.3672 0.797517C31.3064 0.78123 31.2415 0.793156 31.1904 0.829997C31.105 0.891553 31.0029 0.951987 30.8896 1.01609C30.8618 1.03186 30.833 1.04796 30.8038 1.06432C30.7179 1.11241 30.628 1.16278 30.5444 1.21372C30.4318 1.28228 30.3182 1.35909 30.2245 1.44672C30.1312 1.53388 30.0445 1.64372 30.0064 1.78108L30.0064 1.78114C29.4523 3.78169 28.9567 5.79607 28.4328 7.92611C28.2575 8.63844 28.0791 9.3637 27.8943 10.1057C27.878 10.1708 27.8939 10.2397 27.937 10.2911C27.9643 10.3235 28.0011 10.3803 28.054 10.4646C28.0581 10.4712 28.0623 10.4778 28.0665 10.4846C28.1133 10.559 28.1681 10.6465 28.2271 10.7296C28.291 10.8196 28.3667 10.9144 28.4526 10.9895C28.5366 11.0629 28.6513 11.1357 28.7918 11.1426ZM28.7918 11.1426L28.8023 10.9333M28.7918 11.1426C28.7919 11.1426 28.7919 11.1426 28.792 11.1426L28.8023 10.9333M28.8023 10.9333C28.5889 10.9228 28.3935 10.6114 28.2438 10.3726C28.1884 10.2843 28.1392 10.2059 28.0977 10.1564C28.2829 9.41289 28.4615 8.68671 28.6369 7.97386C29.1607 5.84468 29.6552 3.83445 30.2084 1.83709C30.2737 1.60148 30.5888 1.42504 30.9034 1.24882C30.9821 1.20473 31.0608 1.16066 31.1355 1.11567C31.1309 1.10579 31.1263 1.09589 31.1219 1.08599L31.313 1L31.4356 1.17C31.4272 1.17609 31.4187 1.18213 31.4101 1.18814C31.4461 1.25155 31.4847 1.31545 31.5234 1.37933C31.6897 1.65395 31.8557 1.92819 31.8053 2.16103C31.2146 4.85864 30.5653 7.54477 29.8484 10.2166C29.7623 10.5377 29.1469 10.9505 28.8023 10.9333Z"
                    fill="#1D1D1D"
                    stroke="#1D1D1D"
                    stroke-width="0.419229"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <div class="content__body">
                <p v-html="$t('SEND_AN_INQUIRY__CONSENT_SUCCESS')"></p>
              </div>
              <button
                class="btn btn-primary mobile--hide"
                style="width: 700px"
                data-bs-target="#exampleModal-send"
                data-bs-toggle="modal"
                data-bs-dismiss="modal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none">
                  <mask
                    id="mask0_1897_5296"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="28"
                    height="28">
                    <path d="M27.5 0.5H0.5V27.5H27.5V0.5Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_1897_5296)">
                    <mask
                      id="mask1_1897_5296"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="28"
                      height="28">
                      <path
                        d="M0.5 0.500004H27.5V27.5H0.5V0.500004Z"
                        fill="white" />
                    </mask>
                    <g mask="url(#mask1_1897_5296)">
                      <path
                        d="M6.08984 13.0977C6.08984 10.7095 8.02588 8.77344 10.4141 8.77344C12.8022 8.77344 14.7383 10.7095 14.7383 13.0977C14.7383 15.4858 12.8022 17.4219 10.4141 17.4219C8.02588 17.4219 6.08984 15.4858 6.08984 13.0977Z"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M12.8416 26.4453H3.66585C2.23522 26.4453 1.2195 25.0513 1.65756 23.6894C2.82125 20.0712 6.38778 17.453 10.3927 17.453C12.3033 17.453 14.0746 18.0488 15.5311 19.0647"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M17.0078 5.87891C17.0078 3.49073 18.9438 1.55469 21.332 1.55469C23.7202 1.55469 25.6562 3.49073 25.6562 5.87891C25.6562 8.26709 23.7202 10.2031 21.332 10.2031C18.9438 10.2031 17.0078 8.26709 17.0078 5.87891Z"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M14.7734 13.0508C16.4127 11.3169 18.7345 10.235 21.309 10.235C23.2194 10.235 24.9907 10.8308 26.4472 11.8467"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M22.4922 26.4453V18.5352"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M26.4453 22.4902H18.5352"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </g>
                  </g>
                </svg>
                <p @click="close">
                  {{ $t('ASK_COMPANIES_FOR_OFFER_SAME_CATEGORY') }}
                </p>
              </button>
              <button
                class="btn btn-primary mobile--show"
                data-bs-target="#exampleModal-send"
                data-bs-toggle="modal"
                data-bs-dismiss="modal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none">
                  <mask
                    id="mask0_1897_5296"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="28"
                    height="28">
                    <path d="M27.5 0.5H0.5V27.5H27.5V0.5Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_1897_5296)">
                    <mask
                      id="mask1_1897_5296"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="28"
                      height="28">
                      <path
                        d="M0.5 0.500004H27.5V27.5H0.5V0.500004Z"
                        fill="white" />
                    </mask>
                    <g mask="url(#mask1_1897_5296)">
                      <path
                        d="M6.08984 13.0977C6.08984 10.7095 8.02588 8.77344 10.4141 8.77344C12.8022 8.77344 14.7383 10.7095 14.7383 13.0977C14.7383 15.4858 12.8022 17.4219 10.4141 17.4219C8.02588 17.4219 6.08984 15.4858 6.08984 13.0977Z"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M12.8416 26.4453H3.66585C2.23522 26.4453 1.2195 25.0513 1.65756 23.6894C2.82125 20.0712 6.38778 17.453 10.3927 17.453C12.3033 17.453 14.0746 18.0488 15.5311 19.0647"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M17.0078 5.87891C17.0078 3.49073 18.9438 1.55469 21.332 1.55469C23.7202 1.55469 25.6562 3.49073 25.6562 5.87891C25.6562 8.26709 23.7202 10.2031 21.332 10.2031C18.9438 10.2031 17.0078 8.26709 17.0078 5.87891Z"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M14.7734 13.0508C16.4127 11.3169 18.7345 10.235 21.309 10.235C23.2194 10.235 24.9907 10.8308 26.4472 11.8467"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M22.4922 26.4453V18.5352"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M26.4453 22.4902H18.5352"
                        stroke="white"
                        stroke-width="2.34375"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </g>
                  </g>
                </svg>
                <p @click="close">
                  {{ $t('ASK_COMPANIES_FOR_OFFER_SAME_CATEGORY') }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
const emit = defineEmits<{
  (e: 'update:model-value', modelValue: string): void
  (e: 'closed'): void
}>()

const close = () => {
  emit('closed')
}
</script>
<style lang="scss" scoped>
.modal {
  grid-template-rows: initial;
  grid-template-columns: 1fr 3fr;
  max-width: 1080px;
  grid-template-areas:
    'header header'
    'content content';
}
</style>
